import React, { Component } from 'react';
import { connect } from 'react-redux';

import { closeModal, openUpgradeCatalogModal, openForgotPasswordModal } from '../modules/active_modal';
import { getMember, navigate } from '../modules/high_level_actions';

export class ModalLogin extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email:    '',
      password: ''
    };
    this.handleChange = this.handleChange.bind(this);
    this.getMember    = this.getMember.bind(this);
  }

  getMember( evt ) {
    evt.preventDefault();

    let oState      = {};
    let oFakeEvent = {
      preventDefault: () => {},
      currentTarget: { pathname: '/' }
    };

    oState.email    = this.state.email;
    oState.password = this.state.password;

    if (this.props.path === '/reset-password') {
      this.props.dispatch([
        getMember(oState),
        navigate(oFakeEvent),
      ]);
    } else {
      this.props.dispatch(getMember(oState));
    }
  }

  handleChange( sType, event ) {
    var oUpdate      = {};
    oUpdate[ sType ] = event.target.value;
    this.setState( oUpdate );
  }


  render() {
    // Check to see if we already have visitors email
    let {dispatch} = this.props; 
    let sMmodalToShow = (this.props.isSoftLoggedIn) ? '' : 'emailCapture';
    let bButtonDisabled = (this.props.loginError) ? true : false ;
    let errorLink = (this.props.loginError && this.props.loginError.indexOf('already associated') !== -1)
      ? <a onClick={() => dispatch( openForgotPasswordModal() )}> reset your password.</a>
      : <span />;

    return (
      <div className="modal-window login">
        <div className={"modal-close"} onClick={() => dispatch( closeModal() )}>&times;</div>
        <div>
          <h2>Log In</h2>
          <div className={"errorMessage hidden " + (this.props.loginError ? 'showing' : '')}>
            <p>
              {this.props.loginError}
              {errorLink}
            </p>
          </div>
          <form id="login" name="login" onSubmit={this.getMember.bind( this )}>
            <input
              type        = 'email'
              onChange    = {this.handleChange.bind( this, 'email' )}
              value       = {this.state.email}
              name        = 'email'
              placeholder = 'email'
              required
            />
            <input
              type        = 'password'
              onChange    = {this.handleChange.bind( this, 'password' )}
              value       = {this.state.password}
              name        = 'password'
              placeholder = 'password'
              required
            />
            <button
              className="btn-primary full-width"
              disabled={bButtonDisabled}
            >
              Log In
            </button>
          </form>
          <ul className="list">
            <li><a onClick={() => dispatch( openForgotPasswordModal() )}>Forgot Password?</a></li>
            {['CRS','SFC'].includes(this.props.initials) ? '' : <li>Upgrade your <a className="link" onClick={() => dispatch( openUpgradeCatalogModal() )}>catalog membership</a></li>}
          </ul>
        </div>
      </div>
    );
  }
};

function mapStateToProps(state){
    return {
      'loginError': state.loginError,
      'isSoftLoggedIn': state.isSoftLoggedIn,
      'path': state.path,
      'initials': state.store.initials,
    };
}

export default connect(mapStateToProps)(ModalLogin);



// WEBPACK FOOTER //
// ./src/components/ModalLogin.jsx